export const isApplicationLeaf = applicationNode => {
  return applicationNode.directiveId !== undefined;
};
export const isApplicationBranch = applicationNode => {
  return applicationNode.children !== undefined;
};
//# sourceMappingURL=ApplicationSwitcherModel.js.map